import { useApi } from 'services';

export const useGetQuestionnairesById = (idQuestionnaire) => useApi(
    `/v2/questionnaire/${idQuestionnaire}`,
    'GET',
    {},
    {}
);

export const useGetQuestionnairesByIdProduct = (idProduct) => useApi(
    `/v2/questionnaire/product/${idProduct}`,
    'GET',
    {},
    {}
);

export const useGetCountries = (query) => useApi(
    `/v2/questionnaire/options/country`,
    'GET',
    { ...query },
    {},
    true
);

export const useGetStatusOptions = () => useApi(
    `/v2/questionnaire/options/status`,
    'GET',
    {},
    {},
    true
);

export const useGetInterpolationLimits = (idOperation) => useApi(
    `/v2/questionnaire/${idOperation}/options/interpolation-limits`,
    'GET',
    {},
    {},
    true
);